// src/views/waba-setup.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ConnectButton } from "360dialog-connect-button";
import "./waba-setup.css";
import "./common-view.css";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const location = useLocation();
  const [clientData, setClientData] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const client_id = params.get("client_id");
    const channel_id = params.get("channel_id");
    const status = params.get("status");
    const error = params.get("error");

    if (client_id || channel_id || status || error) {
      setClientData({
        client_id,
        channel_id,
        status,
        error
      });

      // Define and immediately call an async function
      const sendDataToBackend = async () => {
        try {
          const response = await fetch("/api/client-onboard", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ client_id, channel_id, status, error })
          });

          if (response.ok) {
            console.log("✅ Onboarding data sent successfully");
          } else {
            console.error(
              "❌ Failed to send onboarding data:",
              await response.text()
            );
          }
        } catch (err) {
          console.error("❌ Error sending onboarding data:", err);
        }
      };

      sendDataToBackend();
    }
  }, [location.search]);

  const handleConnectCallback = callbackObject => {
    console.log("✅ Connected!");
    console.log("Client ID:", callbackObject.client);
    console.log("Channel IDs:", callbackObject.channels);
    if (callbackObject.revokedChannels) {
      console.log("Revoked Channel IDs:", callbackObject.revokedChannels);
    }
    // Optional: persist callbackObject.client and callbackObject.channels to your backend
  };

  return (
    <div className="waba-setup-container">
      <h1>{t('wabaSetup.title')}</h1>
      <p>{t('wabaSetup.subtitle')}</p>

      <ConnectButton
        partnerId={process.env.REACT_APP_360DIALOG_PARTNER_ID}
        label={t('wabaSetup.connectButton')}
        callback={handleConnectCallback}
        queryParameters={{ plan_selection: "premium" }}
      />

      {clientData.status && (
        <div style={{ marginTop: "20px" }}>
          <h3>{t('wabaSetup.onboardingTitle')}</h3>
          <p>
            <strong>{t('wabaSetup.statusLabel')}:</strong> {clientData.status}
          </p>
          <p>
            <strong>{t('wabaSetup.clientIdLabel')}:</strong> {clientData.client_id}
          </p>
          <p>
            <strong>{t('wabaSetup.channelIdLabel')}:</strong> {clientData.channel_id}
          </p>
          <p>
            <strong>{t('wabaSetup.errorLabel')}:</strong> {clientData.error || t('wabaSetup.noError')}
          </p>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
